import { render, staticRenderFns } from "./LodginghomePhone.vue?vue&type=template&id=fd3be016&scoped=true&"
import script from "./LodginghomePhone.vue?vue&type=script&lang=js&"
export * from "./LodginghomePhone.vue?vue&type=script&lang=js&"
import style1 from "./LodginghomePhone.vue?vue&type=style&index=1&id=fd3be016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3be016",
  null
  
)

export default component.exports